import {
  Compass,
  Heart,
  History,
  Home,
  LifeBuoy,
  MessageSquare,
  PackageSearch,
  Settings,
} from "lucide-react";

// Canonical customer account navigation, shared by the avatar dropdown, the
// account sidebar / mobile drawer (AccountMenuItems) and the /account/* shell
// (CustomerAccountShell). Group labels are headings, not destinations. Badge
// rendering stays with each surface: showBadge marks the Messages unread
// count, showSupportBadge the YourBarrio Support unread count.
export const CUSTOMER_NAV_GROUPS = [
  {
    label: "My Barrio",
    items: [
      {
        href: "/customer/home",
        title: "Home",
        description: "Browse marketplace",
        icon: Home,
      },
      {
        href: "/customer/nearby",
        title: "Nearby businesses",
        description: "Discover local spots near you",
        icon: Compass,
      },
      {
        href: "/customer/messages",
        title: "Messages",
        description: "Chat with businesses",
        icon: MessageSquare,
        showBadge: true,
      },
      {
        href: "/customer/saved",
        title: "Saved items",
        description: "Your favorites",
        icon: Heart,
      },
    ],
  },
  {
    label: "Purchases",
    items: [
      {
        href: "/account/orders",
        title: "My Orders",
        description: "Track your orders",
        icon: PackageSearch,
      },
      {
        href: "/account/purchase-history",
        title: "Purchase History",
        description: "View past orders",
        icon: History,
      },
    ],
  },
  {
    label: "Profile",
    items: [
      {
        href: "/customer/settings",
        title: "Account settings",
        description: "Manage your profile and preferences",
        icon: Settings,
      },
    ],
  },
];

// Secondary navigation, rendered after the three groups and before Logout.
export const CUSTOMER_SUPPORT_NAV_ITEM = {
  href: "/support",
  title: "YourBarrio Support",
  // The 232px /account/* shell sidebar cannot fit the full label beside an
  // unread badge (text 129px vs 110px available), so it shows this instead.
  shortTitle: "Support",
  description: "Open and track support requests",
  icon: LifeBuoy,
  showSupportBadge: true,
};

export const CUSTOMER_PRIMARY_NAV_ITEMS = CUSTOMER_NAV_GROUPS.flatMap(
  (group) => group.items
);

export function isCustomerNavItemActive(pathname, href) {
  if (!pathname) return false;
  if (pathname === href) return true;
  return pathname.startsWith(`${href}/`);
}
